const about = {
    title: 'About',
    header: 'About me',
    description:
        "Hi, I'm charbz, a web & UI/UX developer from Montreal. I'm entrusted by my clients to design, develop and assist with the launch of their web sites.",
}

export default about
